import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path fill="currentColor" d="M10 4H5v1h5z" />
      <path
        fill="currentColor"
        d="m16.59 15.86-2.09-2.09a4.97 4.97 0 0 0-1.51-6.99V2c0-1.1-.9-2-2-2H4C2.9 0 2 .9 2 2v10c0 1.1.9 2 2 2h2.37c.91 1.21 2.35 2 3.97 2 1.01 0 1.95-.31 2.74-.82l2.1 2.1c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41zM4 12V2h7v4.07c-.22-.03-.43-.07-.65-.07a5.002 5.002 0 0 0-4.9 6zm6.35 2c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
